export default {
  nav: {
    brand: 'JK Web Studio',
    service: 'Services',
    projects: 'Projects',
    pricing: 'Pricing',
    about: 'About',
    contact: 'Contact',
    langLabel: 'EN',
    langZhTW: '繁體中文',
    langEn: 'English',
  },
  masthead: {
    subtitle: 'Full-Stack PHP Web Development, Maintenance & Cloud Deployment',
  },
  service: {
    heading: 'Build Your Custom Web Solution',
    body: 'My services include: developing all types of websites such as corporate branding, content management, event, e-commerce, community platforms, and API services.<br />Converting design mockups into RWD front-end pages. Maintaining existing PHP websites. Cloud deployment. Regular database backups.<br />Development-focused: if you have a design file, mockup, or wireframe ready, I can build it. <br />Designers and agencies are welcome to discuss long-term collaboration.',
    imgAlt: 'JK Web Studio service showcase',
  },
  projects: {
    heading: 'Projects',
    intro: 'All projects have staging environments, but due to personal data or site ownership, they cannot be made publicly accessible — only screenshots are available. If you would like to know more details or see a live demo, please contact me.',
    hint: 'Click thumbnail to open gallery',
    gallery: {
      cvilux: {
        title: 'Product Website',
        alt: 'Cvilux product website screenshot',
        body: 'A website independently developed while working at a traditional manufacturing company.<br />The front-end was built without a designer — using Bootstrap as the base, with visual suggestions and assets provided by an in-house industrial designer.<br />The back-end used an open-source admin template as the layout, with all functionality custom-built.<br /><a href="https://www.cvilux.com" target="_blank">Visit Website</a><br /><small class="text-warning">Click thumbnail to open gallery</small>',
      },
      herbalshake: {
        title: 'Event Website',
        alt: 'Event website screenshot',
        body: 'An outsourced project from a design agency. Responsible for back-end development, database design, and cloud deployment.<br /><small class="text-warning">Click thumbnail to open gallery</small>',
      },
      ezmaster: {
        title: 'Learning Platform',
        alt: 'Learning platform website screenshot',
        body: 'The client provided a ready-made front-end layout and feature requirements. I implemented the functionality, admin panel, and database design.<br /><small class="text-warning">Click thumbnail to open gallery</small>',
      },
      transportation: {
        title: 'Management System',
        alt: 'Shipment management system screenshot',
        body: 'A simple management system for shipment orders, drivers, and customer data.<br /><small class="text-warning">Click thumbnail to open gallery</small>',
      },
      rdm: {
        title: 'Corporate Website',
        alt: 'Corporate branding website screenshot',
        body: 'A static front-end website built from a designer\'s mockup, outsourced to me for implementation.<br /><small class="text-warning">Click thumbnail to open gallery</small>',
      },
      petid: {
        title: 'E-Commerce',
        alt: 'E-commerce website screenshot',
        body: 'A website commissioned by an entrepreneur. The first version used hand-drawn mockups provided by the client. I built the features, admin panel, and database. Shopping functionality does not include payment gateway.<br /><small class="text-warning">Click thumbnail to open gallery</small>',
      },
      pi2: {
        title: 'Front-End Redesign',
        alt: 'E-commerce website front-end redesign screenshot',
        body: 'A front-end reskin of the e-commerce site after the client commissioned a new design from a separate designer.<br /><small class="text-warning">Click thumbnail to open gallery</small>',
      },
      edm: {
        title: 'EDM Management',
        alt: 'EDM newsletter management system screenshot',
        body: 'Developed while working at an exhibition company. Provides event staff with tools to manage EDM content settings, test sends, recipient lists, and blacklists. Emails are dispatched by an SMTP server at scheduled times.<br /><small class="text-warning">Click thumbnail to open gallery</small>',
      },
      tte2014: {
        title: 'Event Website',
        alt: 'Exhibition event website screenshot',
        body: 'Developed while working at an exhibition company. Front-end designed by an in-house designer; I handled both front-end and back-end page development, feature implementation, and database design.<br /><small class="text-warning">Click thumbnail to open gallery</small>',
      },
      kaley: {
        title: 'Branding Website',
        alt: 'Corporate branding website RWD front-end screenshot',
        body: 'The client provided a Zeplin design file; I converted it into a responsive static front-end website.<br /><small class="text-warning">Click thumbnail to open gallery</small>',
      },
      greenewera: {
        title: 'Awareness Website',
        alt: 'Greenewera 3D panoramic awareness website screenshot',
        body: 'An RWD awareness and event website built with the Babylon.js library, presenting 3D scenes through panoramic photography.<br /><a href="https://greenewera.com.tw/2021" target="_blank">Visit Website</a><br /><small class="text-warning">Click thumbnail to open gallery</small>',
      },
    },
  },
  pricing: {
    heading: 'Pricing & Payment',
    body: '<span class="text-warning">I need to fully understand your requirements before providing a quote.</span><br />After you contact me, I will thoroughly review the system\'s feature details, estimate the time required, and then provide a timeline and quote.<br />Once a project is confirmed, a contract will be signed. Payment is structured as 30% upfront, 50% upon completion, and 20% after final acceptance. Small requests that can be completed within a few working days are exempt from this structure.',
  },
  about: {
    heading: 'About',
    body: 'Full-stack web developer with 18+ years of experience building production-grade applications in PHP/Laravel and Vue.js.<br /><br />I\'ve worked across a wide range of projects — e-commerce platforms, REST APIs, admin dashboards, logistics systems, real-time chat, and a 3D virtual exhibition platform built with Babylon.js. I\'m comfortable owning a project end-to-end: from backend architecture and database design, to frontend implementation, AWS deployment, and CI/CD pipeline setup.<br /><br />If you need someone who can take ownership of a full-stack project without hand-holding, feel free to reach out.<br /><a href="https://www.upwork.com/freelancers/~01b1bced7329313cc6?mp_source=share" target="_upwork">View my Upwork profile</a>',
  },
  contact: {
    heading: 'Contact Me',
  },
  footer: {
    credit: 'This site\'s layout is based on the free Bootstrap theme <a href="http://startbootstrap.com/template-overviews/grayscale/" target="_blank">Grayscale</a>, with modifications.',
    copyright: 'Copyright © JK Web Studio 2026',
  },
}
